import axios from 'axios'
import useAuth from '../store/auth.store'

const request = axios.create({
  baseURL: import.meta.env.VITE_API_SERVER
  // baseURL: "http://localhost:4001/api"
  // baseURL: "https://api.mergensavdag.com//api"
})

console.log('API Server:', import.meta.env.VITE_API_SERVER)

request.defaults.headers.get['Cache-Control'] = 'no-cache';
request.defaults.headers.get['Pragma'] = 'no-cache'; 

request.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] = `Bearer ${localStorage.getItem('token')}`
    return config
  }
)

request.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      const auth = useAuth()
      auth.removeSession()
    }
    return Promise.reject(error.response)
  }
)

export default request